// Sugalarm — branded PDF report downloads (cycle 181).
//
// Reuses the generic authed-fetch → blob → <a download> helper from the
// CSV export module (it is content-type agnostic, so it serves PDFs too).
// The server renders the PDF for the viewed (active) member; we pass the
// browser's local UTC offset so the AGP bins + printed times line up with
// the member's local day (the cycle-177 tz approach).

import { downloadCsv, type DownloadResult } from "./export";

/** JS `getTimezoneOffset()` — minutes such that local = UTC − offset. */
function tzOffset(): number {
  return new Date().getTimezoneOffset();
}

export function downloadAgpReport(days: number): Promise<DownloadResult> {
  return downloadCsv(
    `/api/reports/agp?days=${days}&tz_offset_minutes=${tzOffset()}`,
    `sugalarm_agp_${days}d.pdf`,
  );
}

export function downloadAlarmReport(days: number): Promise<DownloadResult> {
  return downloadCsv(
    `/api/reports/alarms?days=${days}&tz_offset_minutes=${tzOffset()}`,
    `sugalarm_alarms_${days}d.pdf`,
  );
}
